import { getCirugia, postCirugia } from "./ApiHIS"
//const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
export const postCirugiaQuirofano = () =>{
    //const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
    const body = {
            //varEMPCOD: usuarioInfo.Empresa,
            varConsTpo: 'QR',
            //varMCDpto: usuarioInfo.Sede
        }
    return postCirugia('cirugias/preoperatorio/quirofano', body)
}

//Tablero pacientes en cirugia
export const getTableroPacientesEnCirugia=()=>{
    //return getCirugia('consulta/estado')
    return getCirugia('cirugias/consulta/unificacion')
}

export const getCirugiaCirujanoCargo = () =>{
    return getCirugia('cirugias/preoperatorio/cirujano')
}

export const postDXPreoperatorioTodos = (body) =>{
    
    return postCirugia('cirugias/preoperatorio/dxprincipal', body)
}

export const postDXPreoperatorioUno = (body) =>{
 return postCirugia('cirugias/preoperatorio/dxespecifico', body)
   //return postCirugia('preoperatorio/dxprincipal', body)
}

export const postCirugiaDataModificar = (body) =>{
    return postCirugia('cirugias/modifcar/orden', body)
}

export const postCirugiaEntidadAseguradora = (body)=>{
    return postCirugia('cirugias/programacion/contratos/todos',body)
}

export const postCirugiaCirujanoACargoEspecialidad = (body) =>{
    return postCirugia('cirugias/preoperatorio/cirujanos',body)
}

export const postCirugiaEspecialidad = (body) =>{
    return postCirugia('cirugias/preoperatorio/especialidad', body)
}

export const postCirugiaModificar = (body) =>{
    return postCirugia('cirugias/modifcar/orden', body)
}

export const postCirugiaReservadoPor = (body) =>{
    return postCirugia('cirugias/preoperatorio/reservadopor', body)
}

export const postBuscarPacienteProgramacionCirugia = (body) =>{
    return postCirugia('cirugias/modificar1', body)
}

//guardar las modificaciones de cirugia
export const postButtonModificarCirugia= (body)=>{
    return postCirugia('cirugias/actualizar/cirugia', body)
}

//cambiar el estado del paciente
export const postSelectCambiarEstadoPaciente= (body)=>{
    return postCirugia('cirugias/agregar/paciente',body)
}

//todas las entidades
export const postTodasLasEntidades=(body)=>{
    return postCirugia('cirugias/preoperatorio/entidades',body)
}

//programacion de cirugia informacion del estado del usuario
export const postConsultarEstadoPaciente=(body)=>{
    return postCirugia('cirugias/descripcion/consult',body)
}

//consentimiento informado
export const postConsentimientoInformado=(body)=>{
    return postCirugia('cirugias/concentimiento/lista',body)
}

//informacion del consentimiento informado
export const postInformacionConsentimientoInformado=(body)=>{
    return postCirugia('cirugias/concentimiento/select',body)
}

export const postBuscarPacientesEnUnaProgramacionModificar=(body)=>{
    //return postCirugia('modificar/cirugias',body) 
    return postCirugia('cirugias/consult/list/est',body)
}

//todos los estados de un paciente
export const postTodosLosEstadosUser=(body)=>{
    return postCirugia('cirugias/consult/paciente/qx',body)
}

//data cambio de estado a cancelado
export const postDataCancelada=(body)=>{
    return postCirugia('cirugias/data/canaeled',body)
}

//cancelar cirugia
export const postCancelarCirugia=(body)=>{
    return postCirugia('cirugias/update/procir',body)
}

export const postCambioDeEstadoCanceladoUpdateHCCOM51=(body)=>{
    return postCirugia('cirugias/update/procir/canceled',body)
}

export const postEstadoCanceladoUpdateHCCOM5 = (body)=>{
    return postCirugia('cirugias/update/procir/canceled/procedimiento',body)
}


//PROCEDIMIENTO CIRUGIA

//Procedimiento informacion del paciente, cedula, nombre, numero de la cirugia, tipo de documento
export const postProcedimientoModificar = (body) =>{
    return postCirugia('cirugias/procedimiento/cirprincipal',body)
}

//
export const postProcedimientoDetalles = (body) =>{
    return postCirugia('cirugias/procedimiento/detallesqx', body)
}

//
export const postModalProcedimientoDetalles = (body)=>{
    return postCirugia('cirugias/procedimiento/completo', body)
}

//Otros participantes
export const postModalOtrosParticipantes = (body)=>{
    return postCirugia('cirugias/preoperatorio/ayudante',body)
}

//Lista de selección maestro procedimiento
export const postListaSeleccionMaestroProcedimiento = (body) =>{
    return postCirugia('cirugias/procedimiento/maestro',body)
}

//Seleccion de honorarios
export const postSeleccionHonorarios = (body) =>{
    return postCirugia('cirugias/procedimiento/thonorarios',body)
}

//crear procedimiento
export const postCrearProcedimiento = (body)=>{
    return postCirugia('cirugias/add/procedimiento',body)
}

//modificar procedimiento
export const postModificarProcedimientoUser=(body)=>{
    return postCirugia('cirugias/detalles/cirugia',body)
}

//crear otros participantes
export const postCrearOtrosParticipantes=(body)=>{
    return postCirugia('cirugias/add/participantes',body)
}

//modificar otros participantes
export const postModificarOtrosParticipantes=(body)=>{
    return postCirugia('cirugias/actualizar/participantes',body)
}

//listar en la tabla insumos/materiales/paquetes
export const postTablaInsumosMateralesPaquetes=(body)=>{
    return postCirugia('cirugias/preoperatorio/insumos',body)
}

//Informacion del usuario para eliminar un procedimiento
export const postDataUserEliminarUnProcedimiento=(body)=>{
    return postCirugia('cirugias/procedimiento/cirprincipal',body)
}

//eliminar del todo un procedimiento
export const postEliminarProcedimientoTODO=(body)=>{
    return postCirugia('cirugias/delet/proced',body)
}

//update para eliminar un porcedimiento
export const postEliminarUpdateProcedimiento=(body)=>{
    return postCirugia('cirugias/actualizar/cancelacion',body)
}

//seleccion de honorarios crear un procedimiento
export const postHonorariosCrearProcedimiento=(body)=>{
    return postCirugia('cirugias/procedimiento/honorario',body)
}

//eliminar otros participantes
export const postEliminarOtrosParticipantes=(body)=>{
    return postCirugia('cirugias/delete/ayudantes',body)
}

//honorario/ptcodi
export const postProcedimientoObtenerPTCodi=(body)=>{
    return postCirugia('cirugias/honorario/ptcodi',body)
}

//honorario/ptcodi11
export const postProcediminetoBuscarForLiqCod=(body)=>{
    return postCirugia('cirugias/honorario/ptcodi11',body)
}

//turqui
export const postSelectTurquiValidarSiExiste=(body)=>{
    return postCirugia('cirugias/programacion/ultimo/consectuvitur',body)
}

//ultimo consecutivo turqui
export const postUltimoConsecutivoTurquiProgramacionCirugia=(body)=>{
    return postCirugia('cirugias/programacion/ultimo/turqui',body)
}

//insert turqui
export const postInsertTurqui=(body)=>{
    return postCirugia('cirugias/programacion/insertMov/turqui',body)
}

//update turqui
export const postUpdateTurqui=(body)=>{
    return postCirugia('cirugias/programacion/update/cirugiatur',body)
}

//CANASTAS

//opcion
export const getObtenerTodasOpcionesCirugia=()=>{
    return getCirugia('cirugias/obtenerTodasOpcionesCirugia')
}

//todos los paquetes
export const postTodosLosPaquetes=(body)=>{
    return postCirugia('cirugias/procedimiento/paquetes',body)
}

//todos los siministros
export const postTodosLosSuministros=(body)=>{
    return postCirugia('cirugias/procedimiento/paqmateriales',body)
}

//eliminar desde la tabla de procedimiento los insumos/materiales/paquetes servisiosinuso
export const postEliminarInsumosMaterialesPaquetesTablaProcedimiento=(body)=>{
    return postCirugia('cirugias/delete/insumos',body)
}

//Eliminar suministro
export const postEliminarSuministros=(body)=>{
    return postCirugia('cirugias/delet/suministro',body)
}

//los suministro que estan dentro de un paquete
export const postSuministrosEnUnPaquete=(body)=>{
    return postCirugia('cirugias/conetenido/paquete',body)
}

//informacion del paciente (Agregar Paquetes Quirúrgicos) insumos/paquetes/materiales
export const postinfoAgregarPaquetesQuirurgicos=(body)=>{
    return postCirugia('cirugias/info/paquete',body)
}

//Agregar, Crear o Añadir un paquete
export const postAgregarUnPaquete=(body)=>{
    return postCirugia('cirugias/insert/insumo',body)
}

//paquete generico
export const postBuscarUnPaqueteGenerico=(body)=>{
    return postCirugia('cirugias/paquetegenerico/obtenerpaquetegenerico',body)
}

//Agregar, Crear o Añadir un suministro
export const postAgregarSuministro=(body)=>{
    return postCirugia('cirugias/insert/suminnistro',body)
}

export const postCambiodeEstadooUSer=(body)=>{
    return postCirugia('cirugias/descripcion/cambioest',body)
}

//consecutivo
export const postPasaAlEstadoConfirmado=(body)=>{
    return postCirugia('cirugias/descripcion/turni/qx',body)
}

export const postPasaAlEstadoConfirmadoConsecutivo=(body)=>{
    return postCirugia('cirugias/descripcion/turno/qxx',body)
}

//consecutivo de ingreso ambulatorio
export const postConsecutivoIngresoAmbulatorio=(body)=>{
    return postCirugia('cirugias/consecutivo/admision',body)
}
export const postUltimoConsecutivoAmbulatorio=(body)=>{
    return postCirugia('cirugias/consecutivo/admision3',body)
    //return postCirugia('consecutivo/insertMov/update',body)postUpdateConsecutivo
}

//update nuevo consecutivo
export const postUpdateConsecutivo=(body)=>{
 //return postCirugia('consecutivo/insert/cin',body)
 return postCirugia('cirugias/consecutivo/insertMov/update',body)
}

//quirofano repetido
export const postVerificarQuirofanoOcupado=(body)=>{
    return postCirugia('cirugias/descripcion/quirofano/disponible',body)
}

//horario de los quirofanos
export const postHorarioQuirofanos=(body)=>{
    return postCirugia('cirugias/horarios/quirofanos',body)
}

//DESCRIPCION QUIRURGICA
//list preoperatorio button
export const postDQListButtonPreoperatorio=(body)=>{
    //return postCirugia('descripcion/detalle/desc',body)
    return postCirugia('cirugias/descripcion/data/post',body)
}

//todos los pacientes en estado confirmado, nueva version
export const postDescripcionQuirurgicaEstadoConfirmado=(body)=>{
    //return postCirugia('descripcion/principal/realizada',body)
    return postCirugia('cirugias/descripcion/todosUsuarios',body)
}

//
export const postSeleccioneMedicoCirugiaDQX=(body)=>{
    return postCirugia('cirugias/descripcion/medico/table',body)
}

//todos los pacientes en estado confirmado, vieja version
export const postPacientesEstadoConfirmado=(body)=>{
    return postCirugia('cirugias/descripcion/principal',body)
}

//BUscar por cedula, no me esta funcionando
export const postBuscarPorCedulaDQ=(body)=>{
    return postCirugia('cirugias/descripcion/inicio/cedula',body)
}

//informacion del usuario en descripcion quirurgica
export const postInformacionUsuarioDQ=(body)=>{
    return postCirugia('cirugias/descripcion/cirugia/medico',body)
}

//nombre del usuario en descripcion quirurgica
export const postNombreDelPacienteDQ=(body)=>{
    return postCirugia('cirugias/descripcion/cirugia/data',body)
}

//codigo del procedimiento y codigo del medico
export const postCodigoProcedimientoCodigoMedico=(body)=>{
    return postCirugia('cirugias/descripcion/medico/table',body)
}

//Descripción Qx button type select
export const postDescripcionSelect=()=>{
    return postCirugia('cirugias/descripcion/medico/codigo')
}

//especialidad medico
export const postEspecialidadMedicoDQ=(body)=>{
    return postCirugia('cirugias/procedimiento/seleccion/med',body)
}

//procedimiento dx
export const postProcedimientoUserDx=(body)=>{
    return postCirugia('cirugias/procedimiento/seleccion/medico',body)
}
//medico procedimiento
export const postMedicoProceDX=(body)=>{
    return postCirugia('cirugias/procedimiento/seleccion/procedi',body)
}

//
export const postSeleccionCodigoEspecialidad=(body)=>{
    return postCirugia('cirugias/procedimiento/seleccion/codig',body)
}

export const postSelectTextArea=(body)=>{
    return postCirugia('cirugias/descripcion/cirugia/addqx',body)
}

//agregar o modificar descripcion quirurgica
export const postAgregarDX=(body)=>{
    return postCirugia('cirugias/descripcion/add/descripcion',body)
}
//medico tabla de seleccion medico cirugia
// export const postMedicosProcedimientoDQ=(body)=>{
//     return postCirugia('descripcion/medico',body)
// }

//validacion, que el procedimiento tengo asignado un medico
export const postValidarProcedimientoMedico=(body)=>{
    return postCirugia('cirugias/cir/cod',body)
}
export const postValidarProcedimientoQueTengaMedico=(body)=>{
    return postCirugia('cirugias/cir/cod1',body)
}

export const postQXValidarRealizada=(body)=>{
    return postCirugia('cirugias/descripcion/consult/estacir',body)
}

export const postInsertPreoperatorio=(body)=>{
    return postCirugia('cirugias/descripcion/detalle/insert',body)
}

export const postUpdateDescripcionQuirurgica=(body)=>{
    return postCirugia('cirugias/descripcion/detalles/update',body)
}

export const postDataCompletaPacienteDQ=(body)=>{
    return postCirugia('cirugias/descripcion/unifir/data',body)
}

export const postDataParaLuegoUpdateDX=(body)=>{
    return postCirugia('cirugias/descripcion/diagos/todo',body)
}

export const postInsertOrUpdateDescripcionqxUnCirujano=(body)=>{
    return postCirugia('cirugias/descripcion/add/descripciondos',body)
}

////DESCRIPCION QUIRURGICA PROCEDIMIENTO
export const postDQProcedimiento=(body)=>{
    return postCirugia('cirugias/procedimiento/inicio',body)
}

export const postProcedimientoVias=(body)=>{
    return postCirugia('cirugias/descripcion/detalle/vias',body)
}

export const postMaestroProcedimientoDQ=(body)=>{///////////////////////////////////
    return postCirugia('cirugias/procedimiento/lista',body)
}

export const postHonorariosProcedimientoDQ=(body)=>{
    return postCirugia('cirugias/procedimiento/honrios',body)
}

export const postGuardarCirujanosYCirugias=(body)=>{
    return postCirugia('cirugias/procedimiento/insert',body)
}

export const postProcedimientoDxCirugiasYCirujanos=(body)=>{
    return postCirugia('cirugias/procedimiento/todos', body)
}

export const postOtrosParticipantesMedicos=(body)=>{
    return postCirugia('cirugias/descripcion/medico',body)
}

export const postOtrosParticipantesHonorarios=(body)=>{
    return postCirugia('cirugias/procedimiento/honriosmed',body)
}

//descripcion quirurgica procedimiento otros participantes
export const postDQListaProcedimientoOtrosParticipantes=(body)=>{
    return postCirugia('cirugias/procedimiento/ayudantes',body)
}

//modificar otros participantes
export const postModificarOtrosParticipantesDQ=(body)=>{
    return postCirugia('cirugias/descripcion/actualizar/dmedico',body)
}

//modificar cirujanos y cirugias
export const postModificarProcedimientoCirujanosCirugias=(body)=>{
    return postCirugia('cirugias/descripcion/actualizar/dayudantes',body)
}

//validar medico el cual ingreso al sistema no corresponde al medico
export const postValidarMedicoSeleccionadoQX=(body)=>{
    return postCirugia('cirugias/usuruario/medico',body)
}
export const postValidarMedicoSeleQX=(body)=>{
    return postCirugia('cirugias/usuruario/medico1',body)
}

//consultar los suministros de un paquete
export const postConsultarSuministrosDeUnPaquete=(body)=>{
    return postCirugia('cirugias/suministros/info',body)
}
//insert suministros en unpaquete
export const postInsertSuministrosEnUnPaquete=(body)=>{
    return postCirugia('cirugias/suministros/insert',body)
}

//list de complicaciones de paciente
export const postListComplicacionesDescripcionQx=(body)=>{
    return postCirugia('cirugias/descripcion/compli/add',body)
}

//insert complicaciones de paciente
export const postInsertComplicacionesDescripcionQx=(body)=>{
    return postCirugia('cirugias/descripcion/insert/compli',body)
}

//validar medico
export const postSelectMedCodDX=(body)=>{
    return postCirugia('cirugias/descripcion/medico/validar',body)
}

////// PROGRAMACION DE UNA CIRUGIA//////////////////
export const getTipoDeDocumento=()=>{
    return getCirugia('cirugias/programacion/tipo')
}

export const postPacientesParaProgramacionCirugia=(body)=>{
    return postCirugia('cirugias/programacion',body)
}

//Lista de seleccion contratos x empresa
export const postContratosXEmpresa=(body)=>{
    return postCirugia('cirugias/programacion/contratos',body)
}

//obtener el ultimo idcirugia para luego restar
export const postObtenerElUltimoIDCirugia=(body)=>{
    return postCirugia('cirugias/programacion/consult2',body)
}

//todos los contratos de un usuario
export const postContratosDeUnUser=(body)=>{
    return postCirugia('cirugias/programacion/contratos/todos', body)
}

//actualizar idcirugia para programacion de un paciente
export const postActualizarIDCirugia=(body)=>{
    return postCirugia('cirugias/programacion/actulizar',body)
}

//insertar idcirugia para programacion de un paciente
export const postInsertIDCirugia=(body)=>{
    return postCirugia('cirugias/programacion/insert',body)
}

//contratos x usuario
export const postContratosXUsuario=(body)=>{
    return postCirugia('cirugias/programacion/contratos/data',body)
}

//insert eps
export const postInsertUserContratosxEmpresa=(body)=>{
    return postCirugia('cirugias/programacion/contratos/insert',body)
}

//consultar todos los procedimientos para la tabla 
export const postTodosLosProcedimientoDX=(body)=>{
    return postCirugia('cirugias/procedimiento/todos',body)
}

export const postInsertarOtrosParticipantesDQ=(body)=>{
    return postCirugia('cirugias/procedimiento/medico/insert',body)
}

////HOJA DE GASTO
export const postInsertCompletoSuministrosHojaGasto=(body)=>{
    return postCirugia('cirugias/hojagasto/contenedora/union',body)
}

export const postHGprincipal=(body)=>{
    return postCirugia('cirugias/hojagasto/principal',body)
}

//nombre paciente de la tabla
export const postHGnombre=(body)=>{
    return postCirugia('cirugias/hojagasto/nombres',body)
}

//nombre de quirofano
export const postHGquirofano=(body)=>{
    return postCirugia('cirugias/hojagasto/quirofanos',body)
}



//suministros todos hoja de gasto
export const postHGSuministros=(body)=>{
    return postCirugia('cirugias/hojagasto/suministros',body)
}

//ulitmos hoja de gasto
// todos los suministros
export const postHGTodosSuministros=(body)=>{
    return postCirugia('cirugias/hojagasto/select/suministro',body)
}

//consultar farmacia
export const postHGSelectFarmacia=(body)=>{
    return postCirugia('cirugias/hojagasto/select/farmacia',body)
}

//nombre bodega
export const postHGBodega=(body)=>{
    return postCirugia('cirugias/hojagasto/select/bodega',body)
}

//select de bodega
export const postHGSelectBodega=(body)=>{
    return postCirugia('cirugias/hojagasto/select/bode',body)
}

//tipo de transaccion
export const postHGTipoTransaccion=(body)=>{
    return postCirugia('cirugias/hojagasto/select/transaccion',body)
}

//6 saber el ultimo consecutivo
export const postHGConsecutivo=(body)=>{
    return postCirugia('cirugias/hojagasto/select/conesuctivo',body)
}

//7 consecutivo de ingreso
export const postHGConsecutivoIngreso=(body)=>{
    return postCirugia('cirugias/hojagasto/select/ingconesuctivo',body)
}

//8 eps
export const postHGEPS=(body)=>{
    return postCirugia('cirugias/hojagasto/select/eps',body)
}

//9 informacion  del usuario
export const postHGInformacionUsuario=(body)=>{
    return postCirugia('cirugias/hojagasto/select/infoUsuario',body)
}

//10 consecutivo de suministro
export const postHGConsecutivoSuministro=(body)=>{
    return postCirugia('cirugias/hojagasto/select/consecsuministro',body)
}

//11 data para actualizar farmacia
export const postHGDataFarmacia=(body)=>{
    return postCirugia('cirugias/hojagasto/consult/suministro',body)
}

// 12 actualizar farmacia
export const postHGActualizarFarmacia=(body)=>{
    return postCirugia('cirugias/hojagasto/actulizar/farmacia',body)
}

//13 actualizar eps
export const postHGActualizarEps=(body)=>{
    return postCirugia('cirugias/hojagasto/actulizar/eps',body)
}

//14 consecutivo de suministro
export const postHGConSumi=(body)=>{
    return postCirugia('cirugias/hojagasto/consecutivo/suministro',body)
}

//15 actualizar consecutivo de suministro
export const postHGActualizarConsecutivoSuministro=(body)=>{
    return postCirugia('cirugias/hojagasto/consecutivo/add',body)
}

//16 data para luego insertar suministro
export const postHGDataParaInsertarSuministro=(body)=>{
    return postCirugia('cirugias/hojagasto/consecutivo/datainsert',body)
}

//17 actualizar data suministro
export const postHGModificarSuministro=(body)=>{
    return postCirugia('cirugias/hojagasto/consecutivo/insert',body)
}

//10 consultar actualizacion documento
export const postHGConsultarDocNumAcA=(body)=>{
    return postCirugia('cirugias/hojagasto/consult/documento',body)
}

//1 el primer servicios en hoja de gasto
export const postHGPrimerServicio=(body)=>{
    return postCirugia('cirugias/hojagasto/select/usu',body)
}

//11 Actualizar DocNumAcA 
export const postHGActualizarDocNumAcA=(body)=>{
    return postCirugia('cirugias/hojagasto/update/ingreso',body)
}

//2 actulizar usuario hojagasto/update/usu
export const postHGActualizarUsuario=(body)=>{
    return postCirugia('cirugias/hojagasto/update/usu',body)
}

//6 actualizar farmacia
export const postHGUpdateFarmacia=(body)=>{
    return postCirugia('cirugias/hojagasto/update/farmacia',body)
}

//consultar consecutivo de ingreso
export const postHGConsulConsecutivoIngreso=(body)=>{
    return postCirugia('cirugias/hojagasto/select/ingresoc',body)
}

//12 actualizar eps
export const postHGUpdateEPS=(body)=>{
    return postCirugia('cirugias/hojagasto/actulizar/eps',body)
}

///porcons
export const postHGSelectProCons=(body)=>{
    return postCirugia('cirugias/hojagasto/select/procons',body)
}

//29 actualizar contrato
export const postHGActualizarContrato=(body)=>{
    return postCirugia('cirugias/hojagasto/update/contrato1',body)
}

//
export const postHGConsultCodiUser=(body)=>{
    return postCirugia('cirugias/hojagasto/cosult/codusuario',body)
}

//
export const postHGConsultarIngreso=(body)=>{
    return postCirugia('cirugias/hojagasto/select/ingreso1',body)
}

//actualizar contrato
export const postHGUpdateContrato=(body)=>{
    return postCirugia('cirugias/hojagasto/update/contrato',body)
}

//37 actualizar HISCNUM hojagasto/consecutivo/add
export const postHGActualizarHISCNUM =(body)=>{
    return postCirugia('cirugias/hojagasto/consecutivo/add',body)
}

//36 buscar el HISCNUM
export const postHGBuscarHISCNUM=(body)=>{
    return postCirugia('cirugias/hojagasto/select/consehistoria',body)
}

//consecutivo de ingreso y eps
export const postHGConsecutivoIngresoYEPS=(body)=>{
    //return postCirugia('hojagasto/select2/ingre',body)
    return postCirugia('cirugias/hojagasto/select/ingresoc',body)
}

//actualizar suministro 
export const postHGActualizarDataSuministro=(body)=>{
    return postCirugia('cirugias/hojagasto/consecutivo/insert',body)
}

//pabellon eps
export const postHGPabellonEps=(body)=>{
    return postCirugia('cirugias/hojagasto/select/ingreso1',body)
}

//Especialidad y idMEdico
export const postHGEspecialidadIdMedico=(body)=>{
    return postCirugia('cirugias/hojagasto/select/especialidad',body)
}

//consecutivo de historia clinica 
export const postHGHISCNUMParaFolio=(body)=>{
    return postCirugia('cirugias/hojagasto/select/consehistoria',body)
}

//ultimo consecutivo
export const postHGConsecutivoTFUscS=(body)=>{
    return postCirugia('cirugias/hojagasto/consult/ultimosumi',body)
}

//ClaPro
export const postHGClaPro=(body)=>{
    return postCirugia('cirugias/hojagasto/select3/clapro',body)
}

//fecha HISFING
export const postHGFechaHISFING=(body)=>{
    return postCirugia('cirugias/hojagasto/consult/cfolio',body)
}

//actualizar el HISCSEC + 1
export const postHGActulizarHISCSEC=(body)=>{
    return postCirugia('cirugias/hojagasto/consecutivo/update',body)
}

//insert informacion del suministro//AQUI VOY
export const postHGInsertInformacionSuministro=(body)=>{
    return postCirugia('cirugias/hojagasto/insert/sumi66',body)
}

//consecutivo suministro tfcsc
export const postHGConsecutivoSuministroTFCscS=(body)=>{
    //return postCirugia('hojagasto/select/ingresoc',body)
    return postCirugia('cirugias/hojagasto/consecutivo/tfcsc',body)
}

//16 portafolio 
export const postHGPortafolio=(body)=>{
    return postCirugia('cirugias/hojagasto/select/portafolio',body)
}

export const postHGValores=(body)=>{
    return postCirugia('cirugias/hojagasto/select/valoredondeado',body)
}

export const postHGValorUnitario=(body)=>{
    return postCirugia('cirugias/hojagasto/select/valorunitario',body)
}

export const postHGTipoTrans=(body)=>{
    return postCirugia('cirugias/hojagasto/select/tipotransaccion',body)
}

export const postHGCodigoPabellon=(body)=>{
    return postCirugia('cirugias/hojagasto/select/ingpabellon',body)
}

export const postHGFechasContrato=(body)=>{
    return postCirugia('cirugias/hojagasto/select/fechaContrat',body)
}

export const postHGValorFacturadoRegistrado=(body)=>{
    return postCirugia('cirugias/hojagasto/select/valoregistrado',body)
}

export const postHGVigenciaPortafolio=(body)=>{
    return postCirugia('cirugias/hojagasto/select/vifportafolio',body)
}

export const postHGUpdateFolio=(body)=>{
    return postCirugia('cirugias/hojagasto/update/folio',body)
}

export const postHGInsertNumeroActualFechaHora=(body)=>{
    return postCirugia('cirugias/hojagasto/insert/sumi7',body)
    //return postCirugia('hojagasto/update/salida',body)
}

export const postHGCantidadUsada=(body)=>{
    return postCirugia('cirugias/hojagasto/update/cantidadusu',body)
}

export const postHGUpdateSuministroMas=(body)=>{
    return postCirugia('cirugias/hojagasto/update/ultimosuminis',body)
}

export const postHGCambioEstadoPaquete=(body)=>{
    return postCirugia('cirugias/hojagasto/update/paquete',body)
}

export const postHGHojaGastoUPdate=(body)=>{
    return postCirugia('cirugias/hojagasto/estado/paque',body)
}

export const postHGEstadoGasto=(body)=>{
    return postCirugia('cirugias/hojagasto/update/paquete22',body)
}

export const postHGUltimaFecha=(body)=>{
    return postCirugia('cirugias/hojagasto/ultima/salida',body)
}

export const postHGUltimoPq=(body)=>{
    return postCirugia('cirugias/hojagasto/update/salida',body)
    //return postCirugia('hojagasto/update/paquete22',body)
}

export const postHGValoresRegistrados=(body)=>{
    return postCirugia('cirugias/hojagasto/select/valoregistrado',body)
}

export const postHGMasValores=(body)=>{
    return postCirugia('cirugias/hojagasto/update/valorfacturado',body)
}

export const postHGObservacionesUser=(body)=>{
    return postCirugia('cirugias/hojagasto/update/aplicadosumi',body)
}

export const postHGUpdateProcir=(body)=>{
    return postCirugia('cirugias/hojagasto/update/procir',body)
}

export const postHGDataPrincipalTablaSuministros=(body)=>{
    return postCirugia('cirugias/hojagasto/edit/suminitrotable',body)
}

export const postHGTodosLosConsecutivos =(body)=>{
    return postCirugia('cirugias/hojadegasto/consecutivos',body)
}

export const postHGDataSuministro=(body)=>{
    return postCirugia('cirugias/hojadegasto/union/paquetes',body)
}

export const postHGSuministroUpdate=(body)=>{
    return postCirugia('cirugias/hojadegasto/union/hojagastoc',body)
}

//IMPRIMIR PROGRAMACION
export const postIPQuirofanos=(body)=>{
    return postCirugia('cirugias/imprimir/cirugia',body)
}

export const postIPInformacion=(body)=>{
    return postCirugia('cirugias/imprimir/cirugia11',body)
}

export const postIPTodosCirugias=(body)=>{
    return postCirugia('cirugias/imprimir/cirugia33',body)
}

//LIQUIDACION
//1-tabla principan liquidacionQx
export const postLiquidacionQx=(body)=>{
    return postCirugia('cirugias/liquidacion/tprincipal',body)
}

//procedimintos qx 
export const postLiquidacionProcedimientosQx=(body)=>{
    return postCirugia('cirugias/liquidacion/codcir',body)
}

//nombre del procedimiento
export const postLiquidacionDescripcion=(body)=>{
    return postCirugia('cirugias/liquidacion/procedimiento',body)
}

//ForLiqCod
export const postLiquidacionForLiqCod=(body)=>{
    //return postCirugia('liquidacion/formasliq',body)
    return postCirugia('cirugias/liquidacion/formasliq/solo',body)
}

export const postDxPrincipalDxComplicacionLiquidacionQx=(body)=>{
    return postCirugia('cirugias/liquidacion/diagnosticos/union',body)
}

//actualizar la tabla de valores liquidacion qx
export const postUpdateTablaValoresLiquidacionQx=(body)=>{
    return postCirugia('cirugias/liquidacion/update/valores',body)
}

//insertar data TMPFAC1
export const postInsertDataTMPFAC1=(body)=>{
    return postCirugia('cirugias/liquidacion/insert',body)
}

//Actualizar tabla tmpfac
export const postActualizarTablatmpfac=(body)=>{
    return postCirugia('cirugias/liquidacion/update/tmpfac',body)
}

//Actualizar Procir
export const postActualizarProcirLiquidacionQx=(body)=>{
    return postCirugia('cirugias/liquidacion/update/procir',body)
}

//DeleteTMPTMP
export const postDeleteTMPTMPLiquidacionQx=(body)=>{
    return postCirugia('cirugias/liquidacion/delete/cirugia',body)
}

//
export const postDataParaInserttmpfac=(body)=>{
    return postCirugia('cirugias/liquidacion/datatmpfac/insert',body)
}

export const postDataPDFLiquidarUnProcedimineto=(body)=>{
    return postCirugia('cirugias/liquidacion/datospro',body)
}

export const postPreciosLiquidacionQx=(body)=>{
    return postCirugia('cirugias/liquidacion/Honorarios/ImprLiquCirugia',body)
}

export const postPreciosProcedimientosLiquidacionQx=(body)=>{
    return postCirugia('cirugias/liquidacion/contenedora',body)
}

export const postInformacionEmpresa=(body)=>{
    return postCirugia('cirugias/imprimir/titulo/empresa',body)
}

export const postUpdateHCCOM5yHCCOM51=(body)=>{
    return postCirugia('cirugias/consult/data/update/hccom51',body)
}

export const postUpdateHCCOM5yHCCOM51Realizada=(body)=>{
    return postCirugia('cirugias/descripcion/realizada/hccom5',body)
}

export const postTurnosQuirofanos=(body)=>{
    return postCirugia('cirugias/disponibilidad/quirofano',body)
}

export const postDataUserQuirofanos=(body)=>{
    return postCirugia('cirugias/consult/quirofano',body)
}

export const postHonorarioContratoPortafolio=(body)=>{
    return postCirugia('cirugias/contrato/ultimo/procir',body)
}

export const postPDFDescripcionQx=(body)=>{
    return postCirugia('cirugias/descripcion/historial/pdf',body)
}

export const postUsuarioQuienEntregaDespachos=(body)=>{
    return postCirugia('cirugias/user/despachosqx',body)
}

//Novedades Administrativas
export const postInsertNovedadesAdministrativo=(body)=>{
    return postCirugia('cirugias/novedad/administrativa',body)
}

export const postSelectNovedadesAdministrativa=(body)=>{
    return postCirugia('cirugias/novedad/consult',body)
}

//estadistica
export const dataEstadosTotal=()=>{
    return getCirugia('cirugias/porcentajesEstadosPacienteProcedimientoQx')
}

//Reprogramar cirugia
export const updateReprogramarCirugia=(body)=>{
    return postCirugia('cirugias/reprogramar/qx',body)
}

//quirofanos
export const postQuirofanosDetalle=(body)=>{
    return postCirugia('cirugias/cantidad/user/quirofano',body)
}

//insertar en la tabla turqui
export const postInsertQuirofanos=(body)=>{
    return postCirugia('cirugias/turqui/optimize',body)
}

//lista chequeo
export const postListaChequeoInsert=(body)=>{
    return postCirugia('cirugias/cirugia/listachequeo',body)
}

export const postObtenerDataListaChequeo=(body)=>{
    return postCirugia('cirugias/cirugia/obtenerListaChequeoPorCodigo',body)
}

//consentimiento informado
export const postConsentimientoInformadoPrincipal=(body)=>{
    return postCirugia('admisiones/infoPacientes/infoPacienteGeneralConsentimientos',body)
}

export const postGuardarConsentimientoInformadoUsuario=(body)=>{
    return postCirugia('admisiones/consentimientosfirma/crear',body)
}

export const postObtenerTodosLosConsentimientosInformadosUsuario=(body)=>{
    return postCirugia('admisiones/consentimientosfirma/gettablaconsentimientos',body)
}

export const postObtenerTodosLosConsentimientosInformadosDeUnUsuarioConTag=(body)=>{
    return postCirugia('admisiones/consentimientosfirma/getfirmapacientepdf',body)
}

export const postinsertOrUpdateFirmaConsentimiento=(body)=>{
    return postCirugia('admisiones/consentimientosfirma/insertOrUpdateFirmaConsentimiento',body)
}

export const postUpdateConsentimientoInformado=(body)=>{
    return postCirugia('admisiones/consentimientosfirma/update',body)
}

export const postactualizarEstadoConsentimiento=(body)=>{
    return postCirugia('admisiones/consentimientosfirma/actualizarEstadoConsentimiento',body)
}

export const postPreciosPaqueteLiquidacionQx=(body)=>{ 
    return postCirugia('cirugias/liquidacion/preciosProcedimientos',body)
}

export const postProcedimientosQxPaciente=(body)=>{
    return postCirugia('cirugias/procedimientosqx/consultar',body)
}

export const postPDFNotaQx=(body)=>{
    return postCirugia('cirugias/descripcion/infoPDFNota',body)
}

export const postActualizarNotaQx=(body)=>{
    return postCirugia('cirugias/descripcion/actualizaNotaQx',body)
}